// extracted by mini-css-extract-plugin
export default {"lds-spinner":"Icons_lds-spinner__svlyT","white":"Icons_white__S815W","lds-hourglass":"Icons_lds-hourglass__asKPU"};